import { defineComponent as d, computed as o, openBlock as s, createElementBlock as c, createElementVNode as t, toDisplayString as f, createCommentVNode as h, normalizeStyle as n, createStaticVNode as p } from "vue";
const _ = ["viewBox"], m = /* @__PURE__ */ t("mask", { id: "d61a134d-68f4-4f1f-b64b-dc1cc74f9529" }, [
  /* @__PURE__ */ t("circle", {
    cx: "256",
    cy: "256",
    r: "256",
    fill: "#fff"
  })
], -1), v = { mask: "url(#d61a134d-68f4-4f1f-b64b-dc1cc74f9529)" }, k = { key: 0 }, u = /* @__PURE__ */ p('<path fill="#eee" d="M41.3 121.9 512 167v178L43.8 391.3z"></path><path fill="#6da544" d="M0 0h512v167H111z"></path><path fill="#d80027" d="M111 345h401v167H0z"></path><path fill="#0052b4" d="M0 0v512l256-256z"></path><path fill="#ff9811" d="M334 257.1h22.2v32.3h-22.3z"></path><path fill="#6da544" d="M367.3 245a22.3 22.3 0 1 0-44.5 0 11.1 11.1 0 1 0 0 22.1h44.5a11.1 11.1 0 1 0 0-22.2z"></path>', 6), g = { fill: "none" }, x = ["r"], M = /* @__PURE__ */ d({
  __name: "gq",
  props: {
    flagName: {},
    strokeColor: { default: "#000" },
    strokeWidth: { default: 0 }
  },
  setup(i) {
    const e = i, l = o(() => 512 + 2 * e.strokeWidth), a = o(() => -e.strokeWidth), r = o(() => 256 + e.strokeWidth / 2);
    return (z, w) => (s(), c("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      class: "svg-circle-flags",
      viewBox: `${a.value} ${a.value} ${l.value} ${l.value}`
    }, [
      m,
      t("g", v, [
        e.flagName ? (s(), c("title", k, f(e.flagName), 1)) : h("", !0),
        u
      ]),
      t("g", g, [
        t("circle", {
          cx: "256",
          cy: "256",
          r: r.value,
          fill: "none",
          style: n({ stroke: e.strokeColor, strokeWidth: e.strokeWidth })
        }, null, 12, x)
      ])
    ], 8, _));
  }
});
export {
  M as default
};
//# sourceMappingURL=gq-e8306f27.js.map
